import Slide from '@/mixins/Slide'
import Resize from '@/mixins/Resize'
import Button from './Button'

export default
{
    mixins: [
        Slide,
        Resize
    ],

    components:
    {
        Button
    },

    data()
    {
        return {
            current: -1
        }
    },

    mounted()
    {
        this.$textsContainer = this.$refs.textsContainer
        this.$texts = this.$refs.texts

        this.onResized()
    },

    computed:
    {
        content()
        {
            return this.$store.slide05
        }
    },

    methods:
    {
        onResized()
        {
            let maxHeight = 0
            for(const _$text of this.$texts)
            {
                const height = _$text.offsetHeight

                if(height > maxHeight)
                {
                    maxHeight = height
                }
            }

            this.$textsContainer.style.height = `${maxHeight}px`
        }
    }
}
